import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarPanelComponent } from './navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from './services/auth-service.service';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-paneladmin',
  standalone: true,
  imports: [SidebarComponent, NavbarPanelComponent, CommonModule, RouterOutlet],
  templateUrl: './paneladmin.component.html',
  styleUrls: ['./paneladmin.component.scss'],
  providers: [AuthServiceService]
})


export class PaneladminComponent implements OnInit {
  public menuOpen: boolean = false;

  constructor(private authService: AuthServiceService, private router: Router) { }

  ngOnInit() {
    this.authService.requestDataPeriodicallyAdmin().subscribe(()=> {
      console.log('Rodando requisicao de autenticacao periodica');
    },(error: any)=> {
      this.router.navigate(['/admin']);
    }) 
  }

  public async setStatusMenu(status: boolean) {
    this.menuOpen = status;
  }

  
}
